import { render, staticRenderFns } from "./CreateMundial.vue?vue&type=template&id=55d260f4&"
import script from "./CreateMundial.vue?vue&type=script&lang=js&"
export * from "./CreateMundial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports